/**
 * ✅ FERP AUTH HOOK
 *
 * Hook for authentication and tenant management.
 */

import { useState, useCallback } from 'react';

export interface CurrentUser {
  id: string;
  name: string;
  email: string;
  role: string;
  tenantId: string;
}

export const useAuth = () => {
  // Mock current user - in production this would come from auth context
  const [currentUser] = useState<CurrentUser>({
    id: 'demo-user-001',
    name: 'Demo User',
    email: 'demo@claimclock.net',
    role: 'employee',
    tenantId: 'demo-tenant'
  });

  const getCurrentTenantId = useCallback(() => {
    return currentUser.tenantId;
  }, [currentUser]);

  return {
    currentUser,
    getCurrentTenantId,
    isAuthenticated: true,
    isLoading: false
  };
};